import { useTranslation } from "react-i18next";
import banner from "../assets/about-banner.jpg";

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto px-6 md:px-20 py-12">
      <div className="w-full xl:pl-28">
        <p className="text-dark/50 text-xs">{t("about")}</p>
        <h1 className="text-base md:text-xl font-bold text-dark">
          {t("about")}
        </h1>
      </div>
      <div className="flex flex-col-reverse gap-8 lg:grid lg:grid-cols-2 xl:gap-10 mt-10">
        <div className="xl:pl-28 lg:pr-10">
          <img src={banner} alt="about banner" />
        </div>
        <div className="lg:px-10">
          <h2 className="text-2xl text-start max-w-200 text-dark !leading-tight md:text-4xl font-light mb-8 md:mb-4 lg:mb-6 lg:text-5xl xl:text-6xl">
            {t("about")}
          </h2>
          <p className="text-gray-700 leading-relaxed">{t("aboutUsPar")}</p>
          <div className="gap-6 mb-10 mt-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-1 bg-green"></div>
              <p className="text-gray-600">{t("aboutUsItem1")}</p>
            </div>

            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-1 bg-green"></div>
              <p className="text-gray-600">{t("aboutUsItem2")}</p>
            </div>

            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-1 bg-green"></div>
              <p className="text-gray-600">{t("aboutUsItem3")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
